<template>
  <v-app id="inspire">
    <v-app-bar app clipped-left color="green" dark flat>
      <v-app-bar-nav-icon @click.stop="drawer = !drawer" class="mr-3" />
      <v-btn icon href="/">
        <v-icon size="36">mdi-database-eye-outline</v-icon>
      </v-btn>
      <v-toolbar-title class="ml-2">Система аналитики Carbis</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-alert v-if="userFullName" dense text class="ma-0 mr-2">{{
        userFullName
      }}</v-alert>
      <v-alert v-if="userEmail" dense text class="ma-0 mr-2">{{
        userEmail
      }}</v-alert>
      <v-alert v-if="userRoleName" dense text class="ma-0">{{
        userRoleName
      }}</v-alert>
      <v-progress-linear absolute bottom color="green" />
    </v-app-bar>

    <navigation v-model="drawer" />
    <v-snackbar
      v-model="$store.getters.snackbar.show"
      top
      :timeout="2500"
      :color="$store.getters.snackbar.color"
    >
      {{ $store.getters.snackbar.message }}
    </v-snackbar>

    <v-main>
      <keep-alive>
        <router-view />
      </keep-alive>
    </v-main>

    <v-footer app color="green" class="white--text" style='z-index:999999;'>
      <span
        ><a class="footer" href="https://carbis.ru/" target="_blank"
          >Carbis.ru</a
        >
        &copy; 2018-{{ new Date().getFullYear() }}</span
      >
    </v-footer>
  </v-app>
</template>


<script>
import { mapActions, mapGetters } from "vuex";

import navigation from "../components/BasePage/navigation.vue";

export default {
  components: {
    navigation,
  },
  data() {
    return {
      userEditDialog: false,
      drawer: true,
      drawerRight: false,
    };
  },
  computed: {
    ...mapGetters(["userFullName", "userEmail", "userRoleName"]),
  },
  methods: {
    ...mapActions(["logOut"]),
    async confirmLogout() {
      this.logOut();
      location.reload();
    },
  },
};
</script>

<style>
.user-info {
  background-color: #428a45;
  padding: 0.8rem 0.8rem;
  border-radius: 3px;
  white-space: nowrap;
}
.footer {
  text-decoration: none;
  color: white !important;
}
</style>
